var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-box testimonials text-center",class:[
    _vm.hasCenteredClass,
    _vm.hasDenseClass,
    _vm.hasNoMarginClass,
    _vm.data.customClass
  ]},[(_vm.hasTitle)?_c('h2',{staticStyle:{"margin-bottom":"60px"}},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('p',[_vm._v(" "+_vm._s(_vm.localize(this.data.text))+" ")]),_c('v-row',_vm._l((_vm.data.content),function(item,index){return _c('v-col',{key:`testimonial_item_${index}`,attrs:{"cols":"12","lg":"6"}},[_c('testimonial-item',{attrs:{"data":item}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }